"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopHeaderService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var Event_service_1 = require("./Event.service");
/**
 * Used to communicate with the Top Header react component via the event service
 */
var TopHeaderService = /** @class */ (function () {
    function TopHeaderService(eventService) {
        this.eventService = eventService;
    }
    TopHeaderService.prototype.updateCurrentAppType = function (appType) {
        this.eventService.dispatch('topheader.updateCurrentAppType', appType);
    };
    TopHeaderService.prototype.updateCurrentFolder = function (currentFolder) {
        this.eventService.dispatch('topheader.updateCurrentFolder', currentFolder);
    };
    TopHeaderService.prototype.updateProfileLogo = function (logoUrl) {
        this.eventService.dispatch('topheader.updateProfileLogo', logoUrl);
    };
    TopHeaderService.prototype.updateSearchParams = function (searchParams) {
        this.eventService.dispatch('topheader.updateSearchParams', searchParams);
    };
    TopHeaderService.prototype.onSearchOmniBarSelected = function (searchKeyword) {
        this.eventService.dispatch('topheader.onSearchOmniBarSelected', searchKeyword);
    };
    TopHeaderService.prototype.updateAvatar = function (avatarInfo) {
        this.eventService.dispatch('topheader.updateAvatar', avatarInfo);
    };
    TopHeaderService.prototype.changeHeaderVisible = function (isVisible) {
        this.eventService.dispatch('topheader.changeHeaderVisible', isVisible);
    };
    TopHeaderService.prototype.changeLogoVisible = function (isVisible) {
        this.eventService.dispatch('topheader.changeLogoVisible', isVisible);
    };
    TopHeaderService.prototype.changeShadowVisible = function (isVisible) {
        this.eventService.dispatch('topheader.changeShadowVisible', isVisible);
    };
    TopHeaderService.prototype.changeSearchBarPlaceholderVisible = function (isVisible) {
        this.eventService.dispatch('topheader.changeSearchBarPlaceholderVisible', isVisible);
    };
    TopHeaderService.prototype.changeStyle = function (style) {
        this.eventService.dispatch('topheader.changeStyle', style);
    };
    TopHeaderService.prototype.changeSearchBtnStyle = function (style) {
        this.eventService.dispatch('topheader.changeSearchBtnStyle', style);
    };
    TopHeaderService.prototype.changeSearchBarStyle = function (style) {
        this.eventService.dispatch('topheader.changeSearchBarStyle', style);
    };
    TopHeaderService.prototype.updateSearchBarTopPosition = function (top) {
        this.eventService.dispatch('topheader.updateSearchBarTopPosition', top);
    };
    TopHeaderService.prototype.refreshSearchBarTopPosition = function () {
        this.eventService.dispatch('topheader.refreshSearchBarTopPosition');
    };
    TopHeaderService.prototype.buildPropertiesValue = function (propertiesStr) {
        return propertiesStr.split(';');
    };
    TopHeaderService = __decorate([
        CommonService_decorator_1.CommonService('TopHeaderService', { replaceAngularService: 'topHeaderHelper' }),
        __metadata("design:paramtypes", [Event_service_1.EventService])
    ], TopHeaderService);
    return TopHeaderService;
}());
exports.TopHeaderService = TopHeaderService;
//# sourceMappingURL=TopHeader.service.js.map